import React from 'react';

import { Company } from './types';

interface CompanyCardProps {
  company: Company;
  onClick: (company: Company) => void;
}

export const CompanyCard: React.FC<CompanyCardProps> = ({
  company,
  onClick,
}) => {
  const handleClick = () => onClick(company);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleClick();
  };

  return (
    <div
      className="sbe-company-card"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      data-testid={`sbe-company-card-${company.id}`}
    >
      <img className="sbe-company-logo" src={company.logoUrl} alt="" />
      <p className="sbe-company-name">{company.nameJa}</p>
    </div>
  );
};
